// extracted by mini-css-extract-plugin
module.exports = {"social":"social-post_social__3A9tu","giphy":"social-post_giphy__1Djxy"};